// Cuerpo del guardado de una compra, armado SIN tocar el formulario (H26, H27).
//
// El formulario convertía en el lugar la forma de pago (objeto -> código) y los
// porcentajes de retención (opción -> número) antes de enviar. Si el servidor rechazaba
// (p. ej. un producto borrado), quedaba con ese estado: con «Agente de retención» el
// render se caía ([big.js] Invalid number) y el segundo «Guardar» mandaba la forma de
// pago vacía.
import Big from "big.js";

function codeOf(option) {
    return (option !== null && typeof option === "object") ? option.code : option;
}

function valueOf(option) {
    if (option === null || option === undefined) return 0.0;
    return typeof option === "object" ? option.value : option;
}

export function purchasePayload(purchase, { expenseType = null, basicExpenseType = null, makesRetention = false } = {}) {
    const data = { ...purchase };
    data.paymentMethod = codeOf(purchase.paymentMethod);
    if (expenseType) data.expenseType = expenseType;
    if (basicExpenseType) data.basicExpenseType = basicExpenseType;
    if (makesRetention) {
        data.rentPercentage = valueOf(purchase.rentPercentage);
        data.ivaPercentage = valueOf(purchase.ivaPercentage);
    }
    return data;
}

// Tasa de una retención como Big, sea la opción del desplegable ({value}), un número
// o nada. Nunca lanza: los getters de la compra la usan al pintar.
export function retentionRate(option) {
    const value = valueOf(option);
    try {
        return new Big(value === null || value === undefined || value === "" ? "0.0" : value);
    } catch (e) {
        return new Big("0.0");
    }
}
